
export const GET_USERS_SUCCESS='GET_USERS_SUCCESS';
export const GET_USERS_REQUEST='GET_USERS_REQUEST';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const GET_VISITORS_SUCCESS='GET_VISITORS_SUCCESS';
export const GET_VISITORS_REQUEST='GET_VISITORS_REQUEST';
export const GET_VISITORS_FAILURE='GET_VISITORS_FAILURE';

export const DELETE_USER_SUCCESS='DELETE_USER_SUCCESS';
export const DELETE_USER_REQUEST='DELETE_USER_REQUEST';
export const DELETE_USER_FAILURE='DELETE_USER_FAILURE';

